
import Setting from "@/components/trainee/Setting"

export default {
    name: "TraineeSettings",
    components: { Setting },
    fetch() {
        this.settings = {
            is_chat_auto_sending_active:
                !!this.$auth.user.trainee.is_chat_auto_sending_active,
        }
    },
    data() {
        return {
            settings: null,
        }
    },
}
